import { Box, Stack, Typography } from "@mui/material";
import { COLOUR_BLIND_COLOURS } from "./MetricsTable";

export const LegendItem = ({
  color,
  label,
  value,
}: {
  color: string;
  label: string;
  value: number;
}) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color }} />
    <Typography variant="body2">
      {label}: {value}
    </Typography>
  </Stack>
);

export const DonutChart = ({
  total,
  inProgress,
  success,
  failed,
  size = 140,
  strokeWidth = 14,
}: {
  total: number;
  inProgress: number;
  success: number;
  failed: number;
  size?: number;
  strokeWidth?: number;
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const inProgressFraction = total ? inProgress / total : 0;
  const successFraction = total ? success / total : 0;
  const failedFraction = total ? failed / total : 0;

  const inProgressLength = circumference * inProgressFraction;
  const successLength = circumference * successFraction;
  const failedLength = circumference * failedFraction;

  const successPct = total ? (success / total) * 100 : 0;

  const segments = [
    {
      color: COLOUR_BLIND_COLOURS.inProgress,
      length: inProgressLength,
      offset: 0,
    },
    {
      color: COLOUR_BLIND_COLOURS.success,
      length: successLength,
      offset: -inProgressLength,
    },
    {
      color: COLOUR_BLIND_COLOURS.error,
      length: failedLength,
      offset: -(inProgressLength + successLength),
    },
  ];

  return (
    <Box sx={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          {segments.map((s, i) => (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="transparent"
              stroke={s.color}
              strokeWidth={strokeWidth}
              strokeDasharray={`${s.length} ${circumference}`}
              strokeDashoffset={s.offset}
              strokeLinecap="butt"
            />
          ))}
        </g>
      </svg>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">{successPct.toFixed(0)}%</Typography>
        <Typography variant="caption" color="text.secondary">
          {total} total
        </Typography>
      </Box>
    </Box>
  );
};
